import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTagsInput from "react-tagsinput";
import ReactAutosuggest from "react-autosuggest";
import "react-tagsinput/react-tagsinput.css";

import { fetchTagsSuggestions } from "Thunks";
import { selectLanguage } from "Selectors";
import { sortTags, getTagNameAttr } from "Utils";
import _ from "i18n";
import debounce from "lodash.debounce";

export class TagsInput extends Component {
  state = {
    canShowTagIndicator: true,
    showTagIndicator: false,
    tagsAutosuggestIsOpen: false
  };

  static defaultProps = {
    selectedTags: [],
    tagsSuggestions: []
  };

  renderTag = props => {
    let {
      tag,
      key,
      disabled,
      onRemove,
      classNameRemove,
      getTagDisplayValue,
      ...other
    } = props;
    const { lng } = this.props;
    const nameAttr = getTagNameAttr(lng);
    const originalTagName = tag["nameFr"] || tag["nameEn"] || tag["nameNl"];

    const tagDisplayValue = tag[nameAttr];
    const tagIsTranslated =
      tagDisplayValue && $.trim(tagDisplayValue) ? true : false;
    const tagReplacedSynonym = !!tag.replacedSynonym;

    // Init foundation tooltip
    tagReplacedSynonym && setTimeout(() => $("[data-tooltip]").foundation(), 0);

    return (
      <span
        key={key}
        {...other}
        className={
          tagIsTranslated
            ? "react-tagsinput-tag"
            : "react-tagsinput-tag tag-not-translated"
        }
      >
        {tagReplacedSynonym ? (
          <span
            className="icon icon-arrow-right-circle"
            data-tooltip
            data-position="top"
            data-alignment="center"
            title={tag.replacedSynonym[nameAttr]}
            style={{ display: "inline", border: "none", marginRight: "4px" }}
          />
        ) : null}
        {tagIsTranslated ? tagDisplayValue : <span>{originalTagName}</span>}
        {!disabled && (
          <a className={classNameRemove} onClick={e => onRemove(key)} />
        )}
      </span>
    );
  };

  renderInput = ({ addTag, ...props }) => {
    const handleOnChange = (e, { newValue, method }) => {
      if (method === "enter") {
        e.preventDefault();
      } else {
        props.onChange(e);
      }
    };

    const inputValue = (props.value && props.value.trim().toLowerCase()) || "";
    const inputLength = inputValue.length;

    const { lng } = this.props;
    // let lngs = ["en", "fr", "nl"].filter(itm => itm != lng);
    const nameAttr = getTagNameAttr(lng);

    const sanitizedNameAttr =
      nameAttr === "nameFr" ? "sanitizedNameFr" : nameAttr;
    //let sanitizedUserLngNameAttr = userLngNameAttr === 'nameFr' ? 'sanitizedNameFr' : userLngNameAttr;

    const selectedTags = this.props.selectedTags.map(
      t => t[nameAttr] && t[nameAttr].toLowerCase()
    );

    let suggestions = this.props.tagsSuggestions.filter(tag => {
      return (
        tag[nameAttr] &&
        selectedTags.indexOf(tag[nameAttr].toLowerCase()) === -1
        // &&
        // (tag[nameAttr].toLowerCase().slice(0, inputLength) ===
        //   inputValue.toLowerCase() ||
        //   tag[nameAttr]
        //     .toLowerCase()
        //     .includes(" " + inputValue.toLowerCase()) ||
        //   (tag[sanitizedNameAttr] &&
        //     (tag[sanitizedNameAttr].toLowerCase().slice(0, inputLength) ===
        //       inputValue.toLowerCase() ||
        //       tag[sanitizedNameAttr]
        //         .toLowerCase()
        //         .includes(" " + inputValue.toLowerCase()))))
      );
    });

    // let translatedSuggestions = [];
    // let self = this;
    // lngs.forEach(lng => {
    //   let ForeignLngNameAttr = `name${lng.charAt(0).toUpperCase() +
    //     lng.slice(1)}`;
    //   let translatedSuggestionsData = self.props.tagsSuggestions.filter(tag => {
    //     return (
    //       tag[ForeignLngNameAttr].toLowerCase() === inputValue.toLowerCase()
    //     );
    //   });

    //   if (translatedSuggestionsData.length > 0) {
    //     translatedSuggestionsData = sortTags(translatedSuggestionsData, lng);
    //     translatedSuggestionsData = translatedSuggestionsData.map(tag => {
    //       return { ...tag, translated: true, fromLng: lng };
    //     });
    //   }

    //   translatedSuggestions = [
    //     ...translatedSuggestions,
    //     ...translatedSuggestionsData
    //   ];
    // });

    suggestions = sortTags(suggestions, lng);

    // suggestions = [...translatedSuggestions, ...suggestions];

    if (suggestions.length > 10 && !this.state.showTagIndicator) {
      this.setState({
        showTagIndicator: true
      });
    }

    if (suggestions.length <= 10 && this.state.showTagIndicator) {
      this.setState({
        showTagIndicator: false
      });
    }

    return (
      <ReactAutosuggest
        ref={props.ref}
        suggestions={suggestions}
        shouldRenderSuggestions={value => value && value.trim().length > 0}
        getSuggestionValue={suggestion => suggestion[nameAttr]}
        renderSuggestion={suggestion => (
          <span className={suggestion.translated ? "tag-highlight" : ""}>
            {suggestion[nameAttr] +
              (suggestion.fromLng ? " [" + suggestion.fromLng + "]" : "")}
          </span>
        )}
        inputProps={{
          ...props,
          onChange: handleOnChange,
          spellCheck: "false",
          autoCorrect: "off",
          style: { boxShadow: "none" }
        }}
        onSuggestionSelected={(e, { suggestion }) => {
          if (suggestion.isSynonym == "1" && suggestion.parent) {
            suggestion.parent.replacedSynonym = suggestion;
            addTag(suggestion.parent);
          } else {
            addTag(suggestion);
          }
        }}
        onSuggestionsClearRequested={() => {}}
        onSuggestionsFetchRequested={({ value }) =>
          this.debounceLoadSuggestions(value)
        }
      />
    );
  };

  debounceLoadSuggestions = debounce(name => this.loadSuggestions(name), 500);

  loadSuggestions = name => {
    let { lng, fetchTagsSuggestions } = this.props;
    const nameAttr = getTagNameAttr(lng);

    fetchTagsSuggestions({ name, nameAttr, lng });
  };

  canCreateTags = () => false;

  handleTagsChange = (tags, changed, changedIndexes) => {
    let { lng, selectedTags, selectedCommunity } = this.props;
    // let lng = selectedLanguage;

    if (
      changed &&
      changed.length > 0 &&
      tags &&
      tags.length > selectedTags.length
    ) {
      let tag = changed[0];
      let suggestions = this.props.tagsSuggestions;
      const nameAttr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
      let duplicatedTags = [];
      if (tag[nameAttr]) {
        duplicatedTags = selectedTags.filter(
          t =>
            t[nameAttr] &&
            t[nameAttr].toLowerCase() === tag[nameAttr].toLowerCase()
        );
      } else {
        duplicatedTags = selectedTags.filter(
          t => t[nameAttr] && t[nameAttr].toLowerCase() === tag.toLowerCase()
        );
      }

      if (duplicatedTags && duplicatedTags.length > 0) {
        tags.splice(changedIndexes[0], 1); //Don't add duplicated tags
        return;
      }

      if (!tag.id) {
        let filteredTags = [];
        if (tag[nameAttr]) {
          filteredTags = suggestions.filter(
            t =>
              t[nameAttr] &&
              t[nameAttr].toLowerCase() === tag[nameAttr].toLowerCase()
          );
        } else {
          filteredTags = suggestions.filter(
            t => t[nameAttr] && t[nameAttr].toLowerCase() === tag.toLowerCase()
          );
        }

        //If the value already exist in the suggestions
        if (filteredTags && filteredTags.length > 0) {
          tags[changedIndexes[0]] = filteredTags[0];
        } else if (!this.canCreateTags(selectedCommunity)) {
          //remove the tag if the user dont hane permission
          tags.splice(changedIndexes[0], 1);
        } else {
          //else add the new tag (with default names)
          let newTag = {};
          newTag[nameAttr] = tag;
          tags[changedIndexes[0]] = newTag;
        }
      }
    }

    this.props.onChange(tags);
  };

  render() {
    const { selectedTags } = this.props;

    return (
      <ReactTagsInput
        renderInput={this.renderInput}
        renderTag={this.renderTag}
        value={selectedTags}
        onChange={this.handleTagsChange}
        onlyUnique={true}
        inputProps={{ placeholder: _("Select tag ...") }}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: selectLanguage(state),
  tagsSuggestions: state.filter.tagsSuggestions.items,
  tagsSuggestionsFetching: state.filter.tagsSuggestions.fetching
});

const mapDispatchToProps = dispatch => ({
  fetchTagsSuggestions: options => dispatch(fetchTagsSuggestions(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TagsInput);



// WEBPACK FOOTER //
// ./src/components/Common/TagsInput.js